import type { ReactNode } from "react";

type Variant = "active" | "pending" | "failed" | "expired";

interface Props {
  variant: Variant;
  children: ReactNode;
  dot?: boolean;
}

const VARIANT_CLASS: Record<Variant, string> = {
  active: "status-pill status-active",
  pending: "status-pill status-pending",
  failed: "status-pill status-failed",
  expired: "status-pill status-expired",
};

const DOT_COLOR: Record<Variant, string> = {
  active: "bg-terminal",
  pending: "bg-status-pending",
  failed: "bg-status-failed",
  expired: "bg-status-expired",
};

export function Badge({ variant, children, dot = true }: Props) {
  return (
    <span className={VARIANT_CLASS[variant]}>
      {dot && <span className={`inline-block w-1.5 h-1.5 ${DOT_COLOR[variant]}`} />}
      {children}
    </span>
  );
}